import GatsbyImageLink from "../../../../src/components/GastbyImageLink";
import * as React from 'react';
export default {
  GatsbyImageLink,
  React
};